export const DEPLOYMENTS_LIMIT_STORAGE_KEY = "templateVersionDeploymentsLimit";
export const DEPLOYMENTS_LIMIT = 50;
